<script>
    export let active = false;
    export let isTitle = false;
    export let isIcon = false;
    export let isColon = false;
    export let isSpacer = false;
    export let isBigSpacer = false;
</script>


<div data-active={active ? '1' : null} data-title={isTitle ? '1' : null} data-icon={isIcon ? '1' : null} data-colon={isColon ? '1' : null} data-spacer={isSpacer ? '1' : null} data-bigSpacer={isBigSpacer ? '1' : null} data-tiny={(active || isColon || isIcon || isSpacer || isBigSpacer) ? '1' : null}><span><slot/></span></div>


<style lang="less">
    @import "./common.less";

    .desktop ({
        div {
            flex: 1 1 0;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1
        }
        :global(div[data-icon="health"]) div[data-active] {
            color: @healthBarColor;
        }
        :global(div[data-icon="impact"]) div[data-active] {
            color: @impactBarColor;
        }
        :global(div[data-icon="month"]) div[data-active] {
            text-shadow: 0 0 12px rgba(@brightFgR, @brightFgG, @brightFgB, 0.7);
        }
        span {
            flex: 0 0 auto;
        }
        div[data-active] {
            color: @brightFg;
        }
        div[data-colon], div[data-spacer], div[data-bigSpacer] {
            display: none;
        }
        div[data-icon] {
            font-size: 160%;
        }
        :global(div[data-icon="health"]) div[data-title] > span, :global(div[data-icon="impact"]) div[data-title] > span {
            display: inline-block;
            padding-bottom: 3px;
            border-bottom: 1.6px solid black;
        }
        :global(div[data-icon="health"]) div[data-title] > span {
            border-bottom-color: @healthColor;
        }
        :global(div[data-icon="impact"]) div[data-title] > span{
            border-bottom-color: @impactColor;
        }
    });
    .mobile ({
        div:not([data-tiny]) {
            display: none;
        }
        div {
            flex: 0 0 auto;
        }
        div[data-colon] {
            padding: 0 5px 0 2px;
        }
        div[data-spacer] {
            width: 20px;
            flex: 0 0 auto;
        }
        div[data-bigSpacer] {
            flex: 1 1 0;
        }
    });
</style>